"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNormalizedEmail = exports.isEmailValid = void 0;
/**
 * Validate that a string is an email address.
 *
 * The same function exists on the frontend.
 * Changes here should be duplicated in utils/form/index.ts
 *
 * @param {string} email
 * The string to test.
 *
 * @returns {boolean}
 * True if the string provided is a valid email address.
 */
const isEmailValid = (email = '') => {
    // eslint-disable-next-line max-len
    const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i;
    return EMAIL_REGEX.test(email) && email[0] !== '.' && !email.includes('..');
};
exports.isEmailValid = isEmailValid;
/**
 * Normalize an email, providing a consistent representation of the value.
 *
 * @param {string} email
 * The email to normalize.
 *
 * @returns {string}
 * The email, in its normalized form.
 */
const getNormalizedEmail = (email) => email.toLowerCase().trim();
exports.getNormalizedEmail = getNormalizedEmail;
//# sourceMappingURL=email.js.map